// extracted by mini-css-extract-plugin
export default {"container":"page_container__YQAk9","page":"page_page__xAkJ3","sidenav":"page_sidenav__rk55V","title":"page_title__96Ias","input":"page_input__0tW+G","return":"page_return__nozKG"};